export default __webpack_public_path__ + "static/media/151-storehouse.6cff0aa9.png";